export const createRakutenLink = (input) => {
  const rakutenId = process.env.REACT_APP_RAKUTEN_AFFILIATE_ID;

  const isUrl = input.startsWith("http");

  if (isUrl) {
    return `https://hb.afl.rakuten.co.jp/hgc/${rakutenId}/?pc=${encodeURIComponent(input)}`;
  }

  const encoded = encodeURIComponent(input).replace(/%20/g, "+");
  const searchUrl = `https://search.rakuten.co.jp/search/mall/${encoded}/`;

  return `https://hb.afl.rakuten.co.jp/hgc/${rakutenId}/?pc=${encodeURIComponent(searchUrl)}`;
};
